import * as React from 'react';

import { useChatView } from '../../../common/hooks/useChatView';
import { ChatPopup } from '../../components/ChatPopup';

export const ChatPopupContainer: React.FC = () => {
  const { isOpen, src, onClose, onOpen } = useChatView();

  return <ChatPopup isOpen={isOpen} src={src} onClose={onClose} onOpen={onOpen} />;
};

ChatPopupContainer.displayName = 'ChatPopupContainer';
